type ColorsFailureMap<R> = {
  serverFailure: () => R;
  networkFailure: () => R;
};

type ColorsFailureMaybeMap<R> = {
  serverFailure?: () => R;
  networkFailure?: () => R;
  orElse: () => R;
};

abstract class _ColorsFailure extends Error {
  public abstract map<R>(callbacks: ColorsFailureMap<R>): R;
  public abstract maybeMap<R>(callbacks: ColorsFailureMaybeMap<R>): R;
}

class ServerFailure extends _ColorsFailure {
  constructor() {
    super("ServerFailure");
  }

  public map<R>(callbacks: ColorsFailureMap<R>): R {
    return callbacks.serverFailure();
  }

  public maybeMap<R>(callbacks: ColorsFailureMaybeMap<R>): R {
    if (callbacks.serverFailure) return callbacks.serverFailure();
    return callbacks.orElse();
  }
}

class NetworkFailure extends _ColorsFailure {
  constructor() {
    super("NetworkFailure");
  }

  public map<R>(callbacks: ColorsFailureMap<R>): R {
    return callbacks.networkFailure();
  }

  public maybeMap<R>(callbacks: ColorsFailureMaybeMap<R>): R {
    if (callbacks.networkFailure) return callbacks.networkFailure();
    return callbacks.orElse();
  }
}

export type ColorsFailure = ServerFailure | NetworkFailure;

export const ColorsFailure = {
  serverFailure: () => new ServerFailure(),
  networkFailure: () => new NetworkFailure(),
};
